import {useEffect, useState} from 'react';
import API from './API';
import {API_ENDPOINTS} from '../apiConfig';

/**
 * Sdílené přehledy pro odznaky v menu a dashboard (nové požadavky z webu, problémy ve frontě e-mailů).
 * Každý se obnovuje každou minutu, dokud ho používá aspoň jedna komponenta; po akci stačí
 * zavolat refresh…().
 */
const POLL_MS = 60 * 1000;

function createPolledStore(url) {
    let value = null;
    let timer = null;
    let inflight = null;
    const listeners = new Set();

    const refresh = () => {
        if (inflight) return inflight;
        inflight = API.get(url, {meta: {silentError: true}})
            .then(({data}) => {
                value = data;
                listeners.forEach((listener) => listener(value));
                return value;
            })
            .catch(() => value)
            .finally(() => {
                inflight = null;
            });
        return inflight;
    };

    const useStore = (enabled = true) => {
        const [current, setCurrent] = useState(value);
        useEffect(() => {
            if (!enabled) return undefined;
            listeners.add(setCurrent);
            if (!timer) {
                refresh();
                timer = setInterval(refresh, POLL_MS);
            }
            return () => {
                listeners.delete(setCurrent);
                if (!listeners.size && timer) {
                    clearInterval(timer);
                    timer = null;
                }
            };
        }, [enabled]);
        return enabled ? current : null;
    };

    return {refresh, useStore};
}

const inquiryStore = createPolledStore(API_ENDPOINTS.webInquiry.summary);
const emailStore = createPolledStore(API_ENDPOINTS.emailQueue.summary);

export const refreshInquirySummary = inquiryStore.refresh;
export const useInquirySummary = inquiryStore.useStore;

export const refreshEmailQueueSummary = emailStore.refresh;
/** Fronta e-mailů je jen pro profil Admin – ostatním se nenačítá. */
export const useEmailQueueSummary = (profiles = []) => emailStore.useStore(profiles.includes('Admin'));

/** Hodnoty pro odznaky v menu (klíč `badge` v adminMenuConfig). */
export function useMenuBadges(profiles = []) {
    const inquiries = useInquirySummary();
    const emails = useEmailQueueSummary(profiles);
    return {
        inquiriesNew: inquiries?.newTotal || 0,
        emailProblems: emails?.problems || 0
    };
}
